<template>
	<VDataGridV2
		:loader="dataLoader"
		sticky
		paginated
		entity-type="vehicle"
		class="vehicles-registry"
		:context-menu="VehiclesService.contextMenu"
		@row:dblclick="openCard"
	>
		<VDataGridColumnV2
			id="name"
			label="Название"
			width="500px"
			:filter="$core.filters.pattern"
		>
			<template #default="{ row }">
				<div class="title">{{ row.name }}</div>
				<div class="description">ID: {{ row.id }}</div>
			</template>
		</VDataGridColumnV2>

		<VDataGridActionBarV2>
			<VButton theme="primary" @click="openCard()">
				Добавить транспорт
			</VButton>
		</VDataGridActionBarV2>

	</VDataGridV2>
</template>

<script lang="ts">

import DataGridLoader      from '@/lib/components/VDataGridV2/DataGridLoader';
import Vehicle             from '@/domains/Vehicles/Vehicle';
import VehiclesService     from '@/domains/Vehicles/VehiclesService';
import VehicleType         from '@/domains/VehicleTypes/VehicleType';
import UnitsService from "@/domains/Units/UnitsService";

export default defineComponent({
	name: 'VehiclesRegistry',

	props: {
		selectedVehicleType: {
			type:    Object as () => VehicleType | null,
			default: null,
		},
	},

	setup() {
		return {
			VehiclesService,
		}
	},

	data() {
		return {
			dataLoader: new DataGridLoader(VehiclesService.getListPaginated.bind(VehiclesService))
				.useReactiveSource(() => this.buildExternalFilters()),
		};
	},

	methods: {
		buildExternalFilters(): Record<string, unknown> {
			if (!this.selectedVehicleType) return {};
			return { vehicleTypeId: this.selectedVehicleType.id };
		},

		async openCard(row?: Vehicle) {
      if (await VehiclesService.showVehicleCard(row, this.selectedVehicleType )) {
        this.dataLoader.refresh();
      }
		},
	},
});
</script>
